import { Box, CircularProgress, Icon, Typography } from '@mui/material'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { runMonthlyPayroll } from 'services/api/modules/payroll/payroll-dashboard'
import ErrorRunPayrollModal from './ErrorRunPayrollModal'

const ActiveRunComponent = ({
  data,
  period,
  date,
  type,
  emp,
  amount,
  status,
  month,
  year,
  value,
}) => {
  const navigate = useNavigate()
  let time_id = data?.time_id
  const [responseData, setResponseData] = useState(null)
  const [monthRun, setMonthRun] = useState()
  const [yearRun, setYearRun] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [promptErrors, setPromptErrors] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const handleResume = () => {
    // let data = { month: month, year: year }
    // resumePayroll(data)
    // setIsLoading(true)
    // setMonthRun(value)
    // setYearRun(year)

      if (status === 0 && time_id) {
      // Draft already exists on the server with its time_id
      // Navigate directly — PayrollRun will fetch existing data via GET admin/payroll/{time_id}
      navigate(`/app/payroll/regular-payroll/${value}-${year}`, {
        state: { fromDashboardButton: true, item: time_id },
      })
    } else {
      // No existing draft — create a new payroll run via POST
      let data = { month: month, year: year }
      resumePayroll(data)
      setIsLoading(true)
      setMonthRun(value)
      setYearRun(year)
    }
  }
  const handleViewReport = () => {
    navigate(`/app/payroll/payroll-history/${data?.month_word}-${year}`, { state: time_id })
  }
  const { mutate: resumePayroll } = useMutation(runMonthlyPayroll, {
    onSuccess: (res) => {
      setResponseData(res?.data?.data?.time_id)
    },
    onError: (error) => {
      setErrorMessage(error.data.message)
      setPromptErrors(true)
      setIsLoading(false)
    },
  })
  useEffect(() => {
    if (monthRun) {
      if (responseData !== null) {
        setIsLoading(false)
        navigate(`/app/payroll/regular-payroll/${monthRun}-${yearRun}`, {
          state: { fromDashboardButton: true, item: responseData },
        })
      }
    }
  }, [responseData, monthRun]) // eslint-disable-line react-hooks/exhaustive-deps
  const handleCloseErrors = () => {
    setPromptErrors(false)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        columnGap: 2,
        padding: 3.125,
        boxSizing: 'border-box',
        '&:hover': {
          backgroundColor: 'gray-menu-hover.main',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          rowGap: 2,
          justifyContent: 'space-between',
          width: 1,
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ marginBottom: 0.5 }}>
            {period}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
            <Typography variant="subtitle2" color="alternate.main">
              {`Effective by ${date}`}
            </Typography>
            <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', columnGap: 1 }}>
              <Icon sx={{ fontSize: 5, color: 'light-gray-text.main' }}>circle</Icon>
              <Typography component="span" variant="body2" color="light-gray-text.main">
                {type}
              </Typography>
              <Icon sx={{ fontSize: 5, color: 'light-gray-text.main' }}>circle</Icon>
              <Typography component="span" variant="body2" color="light-gray-text.main">
                {`${emp} employees`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{ display: 'flex', alignItems: 'center', columnGap: 4, width: { xs: 1, lg: 'auto' } }}
        >
          {status === 0 && (
            <AdxStatusBar
              status={{
                text: 'Draft',
                bgColor: 'light-yellow-01.main',
                color: 'yellow-02.main',
              }}
            />
          )}
          <Typography variant="subtitle1">{`RM ${amount}`}</Typography>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', minWidth: '66px', cursor: 'pointer' }}
          >
            {isLoading ? (
              <>
                <CircularProgress color="alternate" size={20} />
              </>
            ) : status === 0 ? (
              <Typography
                variant="subtitle1"
                color="alternate.main"
                sx={{ textDecoration: 'underline' }}
                onClick={handleResume}
              >
                Resume
              </Typography>
            ) : (
              <Typography
                variant="subtitle1"
                color="alternate.main"
                sx={{ textDecoration: 'underline' }}
                onClick={handleViewReport}
              >
                View
              </Typography>
            )}
          </Box>
        </Box>
        <ErrorRunPayrollModal
          isModalOpen={promptErrors}
          errorMessage={errorMessage}
          handleClose={handleCloseErrors}
        />
      </Box>
    </Box>
  )
}

export default ActiveRunComponent
